/** @format */

const template = `
<sis-typeahead
  data-cy="location-search-input"
  [id]="'location-search-input'"
  [input-formatter]="ctrl.renderLocation"
  [model]="ctrl.location"
  (select-item)="ctrl.selectItem($event.item)"
  [placeholder]="'SIS_COMPONENTS.LOCATION.SEARCH_LOCATION.SEARCH_LOCATIONS' | translate"
  [result-formatter]="ctrl.renderLocation"
  [typeahead]="ctrl.searchLocations"></sis-typeahead>
`;
export default template;
